export const IGNORED_LAST_BREADCRUMB_ROUTES = ['/documents'];
